import React, { useState } from "react";
import PropTypes from "prop-types";

import LicenseSection from "./LicenseSection";
import TitleSection from "./TitleSection";
import RecognizablePeopleOrPropertySection from "./RecognizablePeopleOrPropertySection";
import ReleasesSection from "./ReleasesSection";
import EditorialUseOnlySection from "./EditorialUseOnlySection";
import AddTagsSection from "./AddTagsSection";
import LocationSection from "./LocationSection";
import DeletePhotoSection from "./DeletePhotoSection";

const EditModalContentRightCol = ({ hasRightColWidth }) => {
    const [
        isRecognizablePeoplePropertyChecked,
        setIsRecognizablePeoplePropertyChecked
    ] = useState(false);

    const [isEditorialUseChecked, setIsEditorialUseChecked] = useState(false);

    return (
        <>
            <LicenseSection />
            <TitleSection />
            <RecognizablePeopleOrPropertySection
                setIsChecked={setIsRecognizablePeoplePropertyChecked}
                isChecked={isRecognizablePeoplePropertyChecked}
            />
            <ReleasesSection
                hasRightColWidth={hasRightColWidth}
                isRecognizablePeoplePropertyChecked={
                    isRecognizablePeoplePropertyChecked
                }
                isEditorialUseChecked={isEditorialUseChecked}
            />
            <EditorialUseOnlySection
                setIsChecked={setIsEditorialUseChecked}
                isChecked={isEditorialUseChecked}
            />
            <AddTagsSection />

            <LocationSection />

            <DeletePhotoSection />
        </>
    );
};

EditModalContentRightCol.propTypes = {
    hasRightColWidth: PropTypes.number
};

export default EditModalContentRightCol;
